function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M90.0019 0H0V60H90.0019V0Z",
  fill: "#F0F0F0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M90.0019 0H0V30H90.0019V0Z",
  fill: "#D80027"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6742 14.9995C14.6742 10.6286 17.7462 6.97722 21.8483 6.08124C21.2178 5.94343 20.5637 5.8689 19.8919 5.8689C14.8489 5.8689 10.7612 9.9566 10.7612 14.9993C10.7612 20.0421 14.8491 24.13 19.8919 24.13C20.5637 24.13 21.2178 24.0553 21.8483 23.9176C17.7462 23.022 14.6742 19.3706 14.6742 14.9995Z",
  fill: "#F0F0F0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4135 6.52124L27.0611 8.51412H29.1567L27.4612 9.74584L28.1088 11.7387L26.4135 10.5072L24.7181 11.7387L25.3659 9.74584L23.6704 8.51412H25.7659L26.4135 6.52124Z",
  fill: "#F0F0F0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M21.3305 10.4343L21.9779 12.4272H24.0735L22.378 13.6589L23.0256 15.6518L21.3305 14.4203L19.6351 15.6518L20.2828 13.6589L18.5874 12.4272H20.6829L21.3305 10.4343Z",
  fill: "#F0F0F0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M31.4969 10.4343L32.1444 12.4272H34.24L32.5445 13.6589L33.1921 15.6518L31.4969 14.4203L29.8016 15.6518L30.4494 13.6589L28.7539 12.4272H30.8494L31.4969 10.4343Z",
  fill: "#F0F0F0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5401 16.3042L30.1877 18.2971H32.2833L30.588 19.5288L31.2356 21.5217L29.5401 20.2901L27.845 21.5217L28.4926 19.5288L26.7974 18.2971H28.8927L29.5401 16.3042Z",
  fill: "#F0F0F0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2869 16.3042L23.9343 18.2971H26.0298L24.3346 19.5288L24.9822 21.5217L23.2869 20.2901L21.5916 21.5217L22.2392 19.5288L20.5439 18.2971H22.6393L23.2869 16.3042Z",
  fill: "#F0F0F0"
});

var SvgSgd = function SvgSgd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 60,
    viewBox: "0 0 91 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSgd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SGD.b7b24082.svg";
export { ForwardRef as ReactComponent };